'use strict';

(() => {
  const template = document.createElement('template');

  template.innerHTML = /* html */ `
    <style>
      .container { background-color: #f5f5f5; padding: 0.2rem .5rem 0; border: 1px solid #c7c7c7; border-radius: 4px; position: relative; }
    </style>

    <div class="container">
      <slot></slot>
    </div>
    `;

  class InputField extends HTMLElement {
    #root = null;

    constructor() {
      super();
      this.#root = this.attachShadow({ mode: 'open' });
      this.#root.appendChild(template.content.cloneNode(true));
      this.container = this.#root.querySelector('.container');
    }
  }

  customElements.define('input-field', InputField);
})();
